import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CodaltComponent } from '../codalt.component';
import { Customer } from '../customer';
import { Filter } from '../filter';
import { PdfStyle } from '../pdf-style';
import { PdfStyleService } from '../pdf-style.service';
import { CustomerService } from '../services/customer/customer.service';
import { PageTitleService } from '../services/page-title/page-title.service';
import { WorkareaService } from '../services/workarea/workarea.service';
import { Workarea } from '../workarea.class';

@Component({
    selector: 'app-customer-table',
    templateUrl: './customer-table.component.html',
    styleUrls: ['./customer-table.component.scss'],
    standalone: false,
})
export class CustomerTableComponent extends CodaltComponent implements OnInit {
    childActive = false;
    customer: Customer;
    filter = new Filter();
    workareas: Workarea[];
    filteredWorkareas: Workarea[];

    type: string;

    pdfStyle: PdfStyle | null = null;
    pdfStyleKey: string | null = null;

    constructor(
        private workareaService: WorkareaService,
        private activatedRoute: ActivatedRoute,
        private pdfStyleService: PdfStyleService,
        private customerService: CustomerService,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit() {
        this.setCustomerTitle();
        this.reload();
        document.body.classList.add('pt-0');
        const styleKey = this.activatedRoute.snapshot.queryParams['pdf_style'];
        if (styleKey) {
            this.pdfStyleKey = styleKey;
            this.subscriptions.add(
                this.pdfStyleService.getStyles().subscribe(styles => {
                    this.pdfStyle = styles.find(s => s.key === styleKey) ?? null;
                    this.pdfStyleService.applyPrimaryColor(this.pdfStyle);
                })
            );
        }
    }

    private parseWorkareaIds(rawValue: any): number[] {
        if (!rawValue || ['undefined', 'null'].includes(String(rawValue).toLowerCase())) {
            return [];
        }

        return String(rawValue)
            .split(',')
            .map((value: string) => +value)
            .filter((value: number) => value > 0);
    }

    public reload(reload = false) {
        Object.assign(this.filter, this.activatedRoute.snapshot.queryParams);
        this.filter.normalizeLayers();
        const rawWorkareaIds =
            this.activatedRoute.snapshot.queryParams['workarea_ids'] ??
            this.activatedRoute.snapshot.queryParams['workareaIds'] ??
            this.activatedRoute.snapshot.queryParams['workareasIds'];
        this.filter.workarea_ids = this.parseWorkareaIds(rawWorkareaIds);

        this.workareaService.getAll(reload, this.filter.statuses).then(workareas => {
            this.workareas = workareas;
            this.filterWorkareas(this.filter);
        });
    }

    private filterWorkareas(filter: any) {
        if (this.workareas) {
            this.filteredWorkareas = filter.apply(this.workareas);
            if (this.filteredWorkareas[0]) {
                this.type = this.filteredWorkareas[0].type;
            }
            setTimeout(() => document.body.appendChild(document.createElement('readyforpuppeteer')));
        }
    }

    private setCustomerTitle() {
        this.pageTitleService.setTitle('Tabel klantgebied');
        this.watchRouteParams(this.RouteParamnames.customerId, ({ customerId }) => {
            if (customerId) {
                this.subscriptions.add(
                    this.customerService
                        .getSingle(+customerId)
                        .subscribe(customer =>
                            this.pageTitleService.setTitle('Tabel klantgebied', customer.customer_name)
                        )
                );
            }
        });
    }
}
